/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { formatPrice } from "@lemmonhq/orders";

interface CreditNoteAmountSectionProps {
  amount: number;
  /** What the sale still has refundable in money (the server re-checks). */
  remaining: number;
  currency: string;
  onChange: (amount: number) => void;
}

/** Free amount refund, as the old "Add Refund" dialog offered. */
export const CreditNoteAmountSection = defineComponent<CreditNoteAmountSectionProps>(
  {
    name: "CreditNoteAmountSection",
    props: ["amount", "remaining", "currency", "onChange"],
    setup(props) {
      const { t } = useLocalization();
      return () => (
        <label class="form-control w-full">
          <div class="label">
            <span class="label-text text-accent">
              {t("general.words.amount")} ({props.currency})
            </span>
            <button
              type="button"
              class="label-text-alt link link-hover"
              onClick={() => props.onChange(Number(props.remaining))}
            >
              {t("reports.tx.credit_note_items.refundable", [
                formatPrice(Number(props.remaining), true, 2, props.currency),
              ])}
            </button>
          </div>
          <input
            type="number"
            step="0.01"
            min="0"
            class="input input-bordered w-full"
            value={props.amount}
            onInput={(e) =>
              props.onChange(parseFloat((e.target as HTMLInputElement).value))
            }
          />
        </label>
      );
    },
  },
);
